module.exports = __webpack_public_path__ + "assets/img/noData.596b3e84.png";